import PageTitle from '@/components/PageTitle';
import ThemeWrapper from '@/components/ThemeWrapper';
import useThemeColors from '@/hooks/useThemeColors';
import AppLayout from '@/layouts/AppLayout';
import CalendarEmbedCard from '@/pages/System/Partials/CalendarEmbedCard';
import { Link, usePage } from '@inertiajs/react';
import clsx from 'clsx';
import React from 'react';

interface InfoSection {
    title: string;
    html_content: string;
}

interface RegionOption {
    key: string;
    label: string;
}

interface PageProps {
    calendarSrc: string | null;
    calendarTokenExpiresAt: string | null;
    infoSection: InfoSection | null;
    regions?: RegionOption[];
    activeRegion?: string | null;
    [key: string]: unknown;
}

const RELOAD_ONLY = [
    'calendarSrc',
    'calendarTokenExpiresAt',
    'infoSection',
    'regions',
    'activeRegion',
];

const OneOnOneBookingContent: React.FC = () => {
    const {
        calendarSrc,
        calendarTokenExpiresAt,
        infoSection,
        regions,
        activeRegion,
    } = usePage<PageProps>().props;
    const colors = useThemeColors();

    return (
        <AppLayout>
            <PageTitle title="Tutoría 1 a 1" />
            <div className="mx-auto max-w-7xl space-y-6">
                {infoSection && (
                    <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm dark:border-neutral-700 dark:bg-neutral-800">
                        <h2 className="mb-6 text-3xl font-bold text-gray-900 dark:text-white">
                            {infoSection.title}
                        </h2>
                        <div
                            className="info-section-content space-y-3 text-gray-700 dark:text-neutral-300 [&_li]:block [&_ul]:list-none [&_ul]:space-y-3 [&_ul_ul]:mt-2 [&_ul_ul]:ml-6"
                            dangerouslySetInnerHTML={{
                                __html: infoSection.html_content,
                            }}
                        />
                    </div>
                )}

                {regions && regions.length > 0 && (
                    <div className="border-b border-gray-200 dark:border-neutral-700">
                        <nav className="-mb-px flex flex-wrap gap-x-6 gap-y-2">
                            {regions.map((region) => (
                                <Link
                                    key={region.key}
                                    href={`?region=${region.key}`}
                                    preserveState
                                    preserveScroll
                                    only={RELOAD_ONLY}
                                    className={clsx(
                                        'border-b-2 px-1 py-3 text-sm font-medium whitespace-nowrap transition-colors',
                                        activeRegion === region.key
                                            ? `border-${colors.primary} text-${colors.primary}`
                                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-neutral-400 dark:hover:border-neutral-600 dark:hover:text-neutral-200'
                                    )}
                                >
                                    {region.label}
                                </Link>
                            ))}
                        </nav>
                    </div>
                )}

                <CalendarEmbedCard
                    calendarSrc={calendarSrc}
                    calendarTokenExpiresAt={calendarTokenExpiresAt}
                />
            </div>
        </AppLayout>
    );
};

const OneOnOneBooking: React.FC = () => (
    <ThemeWrapper>
        <OneOnOneBookingContent />
    </ThemeWrapper>
);

export default OneOnOneBooking;
